import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import { Editor } from '@ckeditor/ckeditor5-core';

@Component({
  selector: 'eiq-bottom-panel-editor',
  templateUrl: './bottom-panel-editor.component.html',
  styleUrls: ['./bottom-panel-editor.component.scss', '_bottom-panel-editor-theme.component.scss']
})
export class BottomPanelEditorComponent {
  @Input() config: any;
  @Input() control: FormControl;
  editor: any = DecoupledEditor;

  constructor() {
    DecoupledEditor.defaultConfig = {
      toolbar: {
        items: ['|', 'bold', 'italic', 'underline', 'link', 'blockQuote', '|', 'bulletedList', 'numberedList', '|', 'undo', 'redo']
      },
      image: {
        resizeUnit: 'px',
        toolbar: []
      },
      table: {
        contentToolbar: []
      },
      list: { properties: { styles: true, reversed: false, startIndex: false } },
      language: 'en'
    };
  }

  onReady(editor: Editor): void {
    const toolbarContainer = document.querySelector('.bottom-panel-editor__editor__toolbar');
    toolbarContainer.appendChild(editor.ui.view.toolbar.element);

    editor.editing.view.focus();
  }
}
